export enum SearchTypeEnum {
  FUZZY = '0',
  CONTAINS = '1',
  START_WITH = '2',
  EXACT = '3',
}
